//angular
import { Component, OnDestroy, OnInit } from '@angular/core';
//others
import { DataSharingService } from 'src/app/_core/services';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'banner-test',
  templateUrl: './banner-test.component.html'
})

export class BannerTestComponent implements OnInit, OnDestroy {
  isEnvironmentSandbox: boolean = false;
  private subs = new Unsubscriber();

  constructor(
    private _shareData: DataSharingService
  ) {}

  ngOnInit(): void {
    //Subscribe to company shipping settings
    this.subs.addSub = this._shareData.currentCompanySettingsEnvironment.subscribe(data => {
      this.isEnvironmentSandbox = (data.environment === 'sandbox' ? true : false);
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
